import { useState } from "react";
import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import WasteWaterTable from "./Table";
import { ShowHideTable } from "../../components/ShowHideTable";
const WasteWaterContent = ({ businessId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable] = useState(false);
  return (
    <div className="component-energy-contents">
      <SubHeaderBox
        subTitle={t("WATER_TREATMENT")}
        subDescription={t("WASTE_WATER_INTRO")}
        isNormal={true}
        number={"8.1.3"}
      />
      {showTable && <WasteWaterTable businessId={businessId} />}
      <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
    </div>
  );
};

export default WasteWaterContent;
